import React from "react";

const Login = () => {
    const API_URL = process.env.REACT_APP_API_URL;
    
    const handleLogin = () => {
        // Redireciona para a rota de login do Flask
        window.location.href = `${API_URL}/auth/login` || "https://sic-conti-backend.vercel.app/";
    };

    return (
        <div className="flex h-screen items-center justify-center bg-gray-100">
            <button
                onClick={handleLogin}
                className="px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg shadow hover:bg-blue-700 transition"
            >
                Login com Microsoft
            </button>
        </div>
    );
};

export default Login;
